import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';
import { useDispatch } from 'react-redux';

const changeType = async ({ shutdownId, data }) => {
  const res = await request.put(
    `/Alert/type/${shutdownId}`,
    data,
    'Не удалось сохранить тип отключения',
    'Error'
  );

  return res;
};

export const useShutdownTypeChange = (options = {}) => {
  const dispatch = useDispatch();

  const changeMutation = useMutation(changeType, {
    ...options,
    onSuccess: (res, { shutdownId, data }) => {
      if (res !== 'Error') {
        dispatch(fetchShutdownsThunk());
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
